import { useDispatch, useSelector } from 'react-redux';
import { selectSurgerySegments, selectShowInvalids } from '@store/order/selectors';
import { setSurgerySegment } from '@store/order/slice';
import SegmentsMap from '@pages/order/surgery-info/SegmentsMap';
import { SegmentsEnum } from '@pages/order/surgery-info/SegmentsEnum';



const SurgerySegments = (): JSX.Element => {

	const surgerySegments = useSelector(selectSurgerySegments);
	const showInvalids = useSelector(selectShowInvalids);

	const dispatch = useDispatch();
	const handleSetSurgerySegment = (value: string) => dispatch(setSurgerySegment(value));

	const segmentsHasHead = surgerySegments && surgerySegments.some(x => x === SegmentsEnum.head);
	const segmentsHasHindpaw = surgerySegments && surgerySegments.some(x => x === SegmentsEnum.hindpaw);

	
	return (
		<div className='surgery-segments'>

			<label className='surgery-label'>
				Potíže/Plánovaný zákrok <span>*</span> {showInvalids && (!surgerySegments || surgerySegments.length === 0) &&
					<p className='form-invalid'>Povinné pole</p>}
			</label>

			<p className='surgery-second-label'>Zvolte místo zranění</p>

			<SegmentsMap
				selectedSegments={surgerySegments}
				onSegmentClick={handleSetSurgerySegment} />

			{segmentsHasHead && !segmentsHasHindpaw &&
				<div className='surgery-segments-warning'>
					<p>Vybrali jste oblast hlavy. V&nbsp;tomto případě Vás musíme upozornit, že&nbsp;funkčnost límce nemůžeme garantovat. Zde záleží na&nbsp;šikovnosti a&nbsp;ohebnosti zvířete. Nákupem límce toto berete na&nbsp;vědomí a&nbsp;přebírate plnou zodpovědnost.</p>
					<p>Není problém vyrobit límec delší, aby&nbsp;tuto oblast pokryl, ale sloužil by&nbsp;pouze pro&nbsp;odpočinek, protože omezí zvíře v&nbsp;pohybu. Pokud chcete zvolit tuto variantu, napište nám prosím informaci do&nbsp;poznámky, případně nás kontaktujte.</p>
				</div>}

			{segmentsHasHindpaw && !segmentsHasHead &&
				<div className='surgery-segments-warning'>
					<p>Vybrali jste oblast spodní části zadních končetin. V&nbsp;tomto případě Vás musíme upozornit, že&nbsp;funkčnost límce nemůžeme garantovat. Zde záleží na&nbsp;šikovnosti a&nbsp;ohebnosti zvířete. Nákupem límce toto berete na&nbsp;vědomí a&nbsp;přebírate plnou zodpovědnost.</p>
					<p>Není problém vyrobit límec delší, aby&nbsp;tuto oblast pokryl, ale sloužil by&nbsp;pouze pro&nbsp;odpočinek, protože omezí zvíře v&nbsp;pohybu. Pokud chcete zvolit tuto variantu, napište nám prosím informaci do&nbsp;poznámky, případně nás kontaktujte.</p>
				</div>}

			{segmentsHasHead && segmentsHasHindpaw &&
				<div className='surgery-segments-warning'>
					<p>Vybrali jste oblast hlavy nebo spodní části zadních končetin. V&nbsp;tomto případě Vás musíme upozornit, že&nbsp;funkčnost límce nemůžeme garantovat. Zde záleží na&nbsp;šikovnosti a&nbsp;ohebnosti zvířete. Nákupem límce toto berete na&nbsp;vědomí a&nbsp;přebírate plnou zodpovědnost.</p>
					<p>Není problém vyrobit límec delší, aby&nbsp;tuto oblast pokryl, ale sloužil by&nbsp;pouze pro&nbsp;odpočinek, protože omezí zvíře v&nbsp;pohybu. Pokud chcete zvolit tuto variantu, napište nám prosím informaci do&nbsp;poznámky, případně nás kontaktujte.</p>
				</div>}

		</div>
	);
};

export default SurgerySegments;